function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../publisher2/tools/AbstractPublisherTool';
import { CoordinateToolComponent } from './CoordinateToolComponent';
import { CoordinateToolHandler } from './CoordinateToolHandler';
var CoordinateTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function CoordinateTool() {
    var _this;
    _classCallCheck(this, CoordinateTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CoordinateTool, [].concat(args));
    _this.index = 120;
    _this.group = 'tools';
    _this.bundleName = 'coordinatetool';
    _this.handler = new CoordinateToolHandler(_this);
    return _this;
  }
  _inherits(CoordinateTool, _AbstractPublisherToo);
  return _createClass(CoordinateTool, [{
    key: "init",
    value: function init(data) {
      if (!data || !data.configuration[this.bundleName]) {
        // new publication and no saved config but ther is a toolconfig -> init with that.
        if (this.toolConfig) {
          this.handler.init(this.toolConfig);
        }
        return;
      }

      // saved configuration -> restore.
      var conf = data.configuration[this.bundleName].conf || {};
      this.handler.init(conf);
      this.storePluginConf(conf);
      this.setEnabled(true);
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {
        component: CoordinateToolComponent,
        handler: this.handler
      };
    }

    /**
    * Get tool object.
    * @method getTool
    *
    * @returns {Object} tool description
    */
  }, {
    key: "getTool",
    value: function getTool() {
      return {
        id: 'Oskari.mapframework.bundle.coordinatetool.plugin.CoordinateToolPlugin',
        title: Oskari.getMsg('coordinatetool', 'display.publisher.toolLabel'),
        config: _objectSpread({}, this.state.pluginConfig || {})
      };
    }

    /**
    * Get values.
    * @method getValues
    * @public
    *
    * @returns {Object} tool value object
    */
  }, {
    key: "getValues",
    value: function getValues() {
      if (!this.isEnabled()) {
        return null;
      }
      var pluginConfig = this.getPlugin().getConfig();
      var state = this.handler.getState();
      for (var key in state) {
        if (key === 'hasSupportedProjections') {
          continue;
        }
        ;
        pluginConfig[key] = state[key];
        // Not save supportedProjections if is not checked
        if (key === 'supportedProjections' && !state[key]) {
          pluginConfig[key] = null;
          delete pluginConfig[key];
        }
        // Not save noUI if is not checked
        if (key === 'noUI' && !state[key]) {
          pluginConfig[key] = null;
          delete pluginConfig[key];
        }
      }
      var json = {
        configuration: {}
      };
      json.configuration[this.bundleName] = {
        conf: pluginConfig,
        state: {}
      };
      return json;
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.CoordinateTool', CoordinateTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { CoordinateTool };